import type { Permission } from '@art-basel/artbasel-lib-platform';
import { SharedRoutes } from '@/shared-routes';
import { useAuthenticationStore } from '@/stores/AuthenticationStore/AuthenticationStore';
import { useAuthorizationStore } from '@/stores/AuthorizationStore/AuthorizationStore';
import { urlWithRedirect } from '@/utils/urlUtils';
import type { RouteLocation } from 'vue-router';

export const AuthGuard = async (to: RouteLocation, ...permissions: Array<Permission>) => {
  return InternalAuthGuard(to, permissions, false);
};

const InternalAuthGuard = async (to: RouteLocation, permissions: Array<Permission> = [], isGuestAllowed: boolean) => {
  if (useAuthenticationStore().isAuthenticated()?.value) {
    if (useAuthenticationStore().isVerified()?.value) {
      const { initAuthorizations, hasAnyPermission, isAppAuthorized } = useAuthorizationStore();
      await initAuthorizations();
      const permissioned = permissions.length > 0 ? hasAnyPermission(...permissions) : true;

      if (!isAppAuthorized() || !permissioned) {
        return { path: SharedRoutes.UNAUTHORIZED };
      }

      return true;
    } else {
      return { path: SharedRoutes.UNVERIFIED };
    }
  } else if (isGuestAllowed) {
    return true;
  } else {
    return urlWithRedirect(
      SharedRoutes.LOGIN,
      to.path !== SharedRoutes.LOGIN && to.path !== SharedRoutes.LOGOUT ? to.fullPath : undefined,
    );
  }
};

export const AuthGuardWithEmailAccess = async (to: RouteLocation) => {
  return InternalAuthGuard(to, [], true);
};
